<template>
    <div class="gallery-item" :class="[rootClasses]">
        <button class="gallery-item--button" @click="onGalleryRequested('audio')"></button>
        <div class="gallery-item--type-indicator">
            <div class="gallery-item--glyph">
                <cmp-icon class="gallery-item--icon"
                        symbol="audio" size="medium" :dynamic-size="true">
                </cmp-icon>
            </div>
        </div>

        <!-- <pre v-if="content" v-text="content"></pre> -->
    </div>
</template>

<script>
    import galleryItemMixin from 'framework/mixins/gallery-item';


    export default {
        mixins: [
            galleryItemMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/gallery-audio/index.vue?6acdd4aa